import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";

import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { RiDiscountPercentLine } from "react-icons/ri";

const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.requiredKidsCount) {
      items = [
        ...items,
        {
          text: "Previous Active Subscription Required",
          value: item.requiredKidsCount,
          type: "number",
        },
      ];
    }

    if (item.discountType) {
      items = [
        ...items,
        {
          text: "Discount Type",
          value: item.discountType,
          type: "text",
        },
      ];
    }

    if (item.discountValue) {
      items = [
        ...items,
        {
          text: "Discount Value",
          value: item.discountValue,
          type: "text",
        },
      ];
    }

    return items;
  };
  return (
    <Card className="item mb-2 borderCream">
     {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        ></div>
      )}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="checkboxCol me-2 mt-2"></div>

            <div className="ms-1 me-2 position-relative">
              <RiDiscountPercentLine size={40} className="text-custom-2" />

              {(item.status === "0" || item.status === 0) && (
                <i className="fas fa-ban position-absolute ms-1 mb-2 banned4"></i>
              )}
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.title}
              </span>

              <span className="">
                <span className="text-custom-4 mt-1 small text-bold">Applied on "{item?.plan?.title}" plan</span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div className="card-tools endColumn mb-1 pt-1" >
          <div>
            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1" style={{ zIndex: 101, position: "relative" }}>
            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            {/* <StatsListing heading="Cart" clickable items={getCart()} /> */}
            <StatsListing items={getItems()} />
          </Col>
        </Row>
        {/* <Row>
          <Col className="mt-1 mb-1 ">
            {item.description && (
              <>
                <Alert variant="light mb-0 pb-1 mb-2 px-2 pt-0 messageWidth">
                  <span className=" m-0 text-bold text-dark px-0 font-small ">
                    Description:{" "}
                    <span className="font-small text-normal ms-0 me-1 px-1 text-dark mb-0">
                      {item.description}
                    </span>
                  </span>
                </Alert>
              </>
            )}
          </Col>
        </Row> */}
      </Card.Body>
    </Card>
  );
};

export default Item;
